import $ from "jquery";
import "jquery-validation";

const vacancyForm = () => {
  const el = {
    form: ".apply-form",
    first_name: "input[name='voornaam']",
    last_name: "input[name='achternaam']",
    email: "input[name='email']",
    phone: "input[name='phoneNumber']",
    cv: "input[name='cv']",
    motivation: "input[name='motivation']",
    personal_contact_preference: "input[name='radio-how-to-contact']:checked",
    vacancy: "input[name='vacancy']",
    submit_button: ".js-submit-button",
    acceptance_privacy: "input[name='acceptance_privacy']",
  };

  const getFirstName = () => {
    const $firstName = $(el.first_name);
    return $firstName.val();
  };

  const getLastName = () => {
    const $lastName = $(el.last_name);
    return $lastName.val();
  };

  const getEmail = () => {
    const $email = $(el.email);
    return $email.val();
  };

  const getPhone = () => {
    const $phone = $(el.phone);
    return $phone.val();
  };

  const getPersonalContactPreference = () => {
    const $personalContactPreference = $(el.personal_contact_preference);
    return $personalContactPreference.val();
  };

  const getCv = () => {
    const $cv = $(el.cv);
    return $cv[0].files[0];
  };

  const getMotivation = () => {
    const $motivation = $(el.motivation);
    return $motivation[0].files[0];
  };

  const getVacancy = () => {
    const $vacancy = $(el.vacancy);
    return $vacancy.val();
  };

  const getAction = () => {
    return themeObj.ajax.vacancy_submission.action;
  };

  const getNonce = () => {
    return themeObj.ajax.nonce;
  };

  const buildData = () => {
    let fd = new FormData();
    fd.append("first_name", getFirstName());
    fd.append("last_name", getLastName());
    fd.append("email", getEmail());
    fd.append("phone", getPhone());
    fd.append("personal_contact_preference", getPersonalContactPreference());
    fd.append("cv", getCv());
    fd.append("motivation", getMotivation());
    fd.append("vacancy", getVacancy());
    fd.append("action", getAction());
    fd.append("nonce", getNonce());

    return fd;
  };

  const handleOnClickSubmit = (e) => {
    e.preventDefault();

    const fd = buildData();

    $.ajax({
      url: themeObj.ajaxUrl,
      method: "POST",
      data: fd,
      // cache: false,
      processData: false,
      contentType: false,
    })
      .done((response) => {
        alert(response.message);
        window.location.reload();
      })
      .fail((err) => {
        alert(err.responseText);
      });
  };

  const validate = () => {
    const validator = $(el.form).validate({
      rules: {
        voornaam: {
          required: true,
        },
        achternaam: {
          required: true,
        },
        email: {
          required: true,
          email: true,
        },
        phoneNumber: {
          required: true,
        },
        cv: {
          required: true,
        },
        acceptance_privacy: {
          required: true,
        },
      },
      messages: {
        voornaam: {
          required: themeObj.jquery_validation_error.first_name.required,
        },
        achternaam: {
          required: themeObj.jquery_validation_error.last_name.required,
        },
        email: {
          email: themeObj.jquery_validation_error.email.email,
          required: themeObj.jquery_validation_error.email.required,
        },
        phoneNumber: {
          required: themeObj.jquery_validation_error.phoneNumber.required,
        },
        cv: {
          required: themeObj.jquery_validation_error.cv.required,
        },
        acceptance_privacy: {
          required:
            themeObj.jquery_validation_error.aceptanace_privacy.required,
        },
      },
    });

    validator.form();
    return $(el.form).valid();
  };

  const init = () => {
    $(document).on("click", el.submit_button, (e) => {
      const formValidate = validate();
      if (!formValidate) return;
      handleOnClickSubmit(e);
    });
  };

  init();
};

try {
  vacancyForm();
} catch (error) {
  console.log(error);
}
